import React from "react";
import { Link } from "react-router-dom";
import InnerHero from "../components/InnerHero";
import { ArrowLeft, BookOpen, Building2, Images, LibraryBig } from "lucide-react";

const infrastructureImages = [
  {
    src: "/Library/1.jpg",
    title: "Library Infrastructure",
    alt: "KLS VDIT library infrastructure",
  },
  {
    src: "/Library/2.jpg",
    title: "Reading Space",
    alt: "KLS VDIT library reading space",
  },
  {
    src: "/Library/3.jpg",
    title: "Book Collection",
    alt: "KLS VDIT library book collection",
  },
  {
    src: "/Library/4.jpg",
    title: "Reference Area",
    alt: "KLS VDIT library reference area",
  },
  {
    src: "/Library/5.jpg",
    title: "Learning Facility",
    alt: "KLS VDIT library learning facility",
  },
  {
    src: "/Library/6.jpg",
    title: "Library Resources",
    alt: "KLS VDIT library resources",
  },
  {
    src: "/Library/7.jpg",
    title: "Student Reading Area",
    alt: "KLS VDIT library student reading area",
  },
];

const facilities = [
  "Separate library building named JNAN SUDHA",
  "655 sq. m. learning space",
  "Open-access book collection",
  "Spacious reading halls",
  "Digital Library with 30 multimedia systems",
  "Language Laboratory",
  "High-speed internet-enabled environment",
  "Organized collection using Dewey Decimal Classification",
];

const LibraryInfrastructure = () => (
  <main>
    <InnerHero
      title="Library Infrastructure"
      image="/Library/hero.jpg"
      breadcrumbs={[
        { label: "Campus Life", to: "/campus" },
        { label: "Library", to: "/library" },
        { label: "Infrastructure" },
      ]}
    />

    <section className="bg-surface-alt/60 border-b border-brand/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 text-xs font-sans-ui font-semibold tracking-wider text-brand">
        <Link to="/library" className="inline-flex items-center gap-2 uppercase hover:underline">
          <ArrowLeft size={14} /> Back to Library
        </Link>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-10">
          <section>
            <div className="flex items-end justify-between gap-4 mb-5">
              <div>
                <h2
                  className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  <Images size={22} /> Library Images
                </h2>
                <p className="text-sm text-[#3a3a3a]/80 italic mt-1">
                  Library spaces and learning facilities
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {infrastructureImages.map((image) => (
                <figure
                  key={image.src}
                  className="bg-white border border-brand/15 overflow-hidden"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <figcaption className="px-4 py-3">
                    <span className="text-xs uppercase tracking-widest text-brand font-semibold font-sans-ui">
                      {image.title}
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </section>

          <section>
            <h2
              className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2 mb-5"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              <Building2 size={22} /> Facilities
            </h2>
            <div className="bg-white border border-brand/15 p-5">
              <ul className="grid md:grid-cols-2 gap-x-6 gap-y-2 pl-5 list-disc text-sm text-[#2a2a2a]/85 leading-relaxed">
                {facilities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        </div>

        <aside className="space-y-5">
          <div className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36 self-start">
            <h4 className="text-xs uppercase tracking-widest text-brand font-semibold font-sans-ui">
              Infrastructure Facts
            </h4>
            <div className="mt-3 space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <LibraryBig size={14} className="text-brand" />
                <span>Building: <strong>JNAN SUDHA</strong></span>
              </div>
              <div>Area: <strong>655 sq. m.</strong></div>
              <div>Digital Systems: <strong>30</strong></div>
              <div>Collection Access: <strong>Open Access</strong></div>
              <div>Classification: <strong>DDC System</strong></div>
            </div>

            <Link
              to="/library"
              className="block mt-5 text-center bg-brand text-surface py-2.5 text-sm font-semibold font-sans-ui hover:bg-brand-dark transition"
            >
              Library Overview
            </Link>

            <div className="mt-6 pt-5 border-t border-brand/10">
              <h4 className="text-xs uppercase tracking-widest text-brand font-semibold font-sans-ui mb-3">
                Learning Spaces
              </h4>
              <ul className="space-y-1.5 text-sm text-[#2a2a2a]">
                {["Reading halls", "Digital Library", "Language Laboratory", "Reference area"].map((item) => (
                  <li key={item} className="flex items-center gap-1">
                    <BookOpen size={12} className="text-brand" /> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </section>
  </main>
);

export default LibraryInfrastructure;
